var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM11.3328 5.64788C11.2408 5.29444 10.9697 5.01612 10.6255 4.92167C10.0017 4.75 7.5 4.75 7.5 4.75C7.5 4.75 4.99832 4.75 4.37445 4.92167C4.03023 5.01612 3.75914 5.29444 3.66714 5.64788C3.5 6.28845 3.5 7.625 3.5 7.625C3.5 7.625 3.5 8.9615 3.66714 9.60212C3.75914 9.95556 4.03023 10.2339 4.37445 10.3284C4.99832 10.5 7.5 10.5 7.5 10.5C7.5 10.5 10.0017 10.5 10.6255 10.3284C10.9697 10.2339 11.2408 9.95556 11.3328 9.60212C11.5 8.9615 11.5 7.625 11.5 7.625C11.5 7.625 11.5 6.28845 11.3328 5.64788Z",
    fill: "#334D6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 9V6.5L8.75 7.75005L6.75 9Z",
    fill: "#334D6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.96e5db666f5b95c3c2e0b4b9ac9ec2c4.svg";
export { ForwardRef as ReactComponent };